import { render, staticRenderFns } from "./commonData.vue?vue&type=template&id=6dfc2af0&scoped=true&"
import script from "./commonData.vue?vue&type=script&lang=js&"
export * from "./commonData.vue?vue&type=script&lang=js&"
import style0 from "./commonData.vue?vue&type=style&index=0&id=6dfc2af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfc2af0",
  null
  
)

export default component.exports